import React from 'react'
import { HomeComponentProps } from './home.constants'
import { useHomeStyles } from './home.styles'
import { Grid } from '@material-ui/core'
import { GridItem } from '../../../shared/grid-item'
import { Filter } from '../../../shared/filter'
import { ListedItem, ListedItemProps } from '../../../components/listed-item'
import { AppPagination } from '../../../components/app-pagination'
import {
  ApplyType,
  FilterParamsType,
} from '../../../shared/filter/filter.constants'
import { EmptySearchResultComponent } from '../../../components/empty-search-result-component'
import { useScreenSize } from '../../../hooks/use-screen-size'
import { useTranslation } from 'react-i18next'
import { PlaceholderArrayComponent } from '../../../components/placeholder-array-component'
import { ItemState } from '../../../models'
import { ShowItemsSelect } from '../../../components/show-items-select'
import { ScreenSize } from '../../../settings/device'

export const Home: React.FC<HomeComponentProps> = (
  props: HomeComponentProps
) => {
  const {
    itemsList,
    query,
    changeQueryParamsAction,
    totalPages,
    loading,
    initialMaxPrice,
    initialMinPrice,
    firstRender,
    cancelHandler,
    categories,
    nonprofits,
    isFilterCollapsed,
    changeFilterCollapsedHandler,
  } = props

  const classes = useHomeStyles()

  const { t } = useTranslation()

  /*Device Type*/
  const screenSize = useScreenSize()

  /*Filter Change Handler*/
  const onFilterChanged = (
    data: FilterParamsType,
    apply?: ApplyType,
    isStartPagingInBegin?: boolean
  ) => {
    changeQueryParamsAction(data, apply, isStartPagingInBegin)
  }

  /*Pagination Change Handler*/
  const onPaginationHandler = (pageIndex: number) => {
    changeQueryParamsAction(
      {
        pageIndex,
      },
      true
    )
  }

  const onPageSizeChange = (pageSize: number) => {
    changeQueryParamsAction({ pageSize }, true, true)
  }

  const renderFilter = () => (
    <Filter
      searchText={query.searchText}
      categories={categories}
      nonprofitCategoryId={query.nonprofitCategoryId}
      nonprofits={nonprofits}
      nonprofitId={query.nonprofitId}
      priceValue={[...query.priceValue]}
      initialMinPrice={initialMinPrice}
      initialMaxPrice={initialMaxPrice}
      onFilterChanged={onFilterChanged}
      condition={query.condition}
      showSold={query.showSold}
      loading={loading}
      cancelHandler={cancelHandler}
      isFilterCollapsed={isFilterCollapsed}
      setFilterCollapsed={changeFilterCollapsedHandler}
      screenSize={screenSize}
    />
  )

  return (
    <Grid container spacing={1}>
      {screenSize !== ScreenSize.Desktop && (
        <Grid item xs={12}>
          <div className={classes.mobileControls}>
            <div className={classes.mobileFilterControl}>{renderFilter()}</div>
            <ShowItemsSelect
              value={query.pageSize}
              onChange={onPageSizeChange}
              disabled={loading}
              label={t('home.showItems')}
              idSuffix="search-mobile"
              className={classes.mobileShowItemsSelect}
            />
          </div>
        </Grid>
      )}
      {screenSize === ScreenSize.Desktop && (
      <Grid item xs={12} lg={3} xl={2} md={3}>
        <div className={classes.filterContainer}>
          {renderFilter()}
        </div>
      </Grid>
      )}
      <Grid item xs={12} xl={10} lg={9} md={9}>
        <Grid container spacing={1}>
          {firstRender && <PlaceholderArrayComponent />}
          {!itemsList.length && !firstRender && (
            <Grid xs={12} item>
              <EmptySearchResultComponent
                title={t('emptySearchResult.title')}
                description={t('emptySearchResult.description')}
              />
            </Grid>
          )}
          {itemsList.map((item: ListedItemProps, key: number) => (
            <GridItem key={key} xxxs={12} xxs={6} xs={4} md={4} lg={3} xl={2}>
              <ListedItem
                {...item}
                state={item.state == ItemState.Active ? undefined : item.state}
              />
            </GridItem>
          ))}
          {!firstRender && totalPages > 1 && (
            <Grid item xs={12}>
              <AppPagination
                spacing="minimal"
                count={totalPages}
                disabled={loading}
                page={query.pageIndex}
                onChange={(e, page) => onPaginationHandler(page)}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}
